module.exports = __webpack_public_path__ + "fonts/roboto-all-500.6f69d99b.woff2";